const extractTypeFromTypes = (listingType, types) => Array.isArray(types) ? types?.find(_ref => {
  let {
    code
  } = _ref;
  return listingType === code;
})?.name ?? listingType : listingType;
const getListingType = (listing, brand) => {
  const listingType = extractTypeFromTypes(listing.type || listing.listingType, listing.listingTypes);

  // Used FORD_BLUE_CERT vehicles will be treated as Certified on Ford Brand
  if (brand === 'ford' && listingType?.toLowerCase() === 'used') {
    return 'Certified';
  }
  return listingType;
};
const extractName = attribute => {
  if (attribute !== null && typeof attribute === 'object') {
    return attribute?.name ?? null;
  }
  return attribute;
};
export default function hydrateInventory(id, inventory, owners, brand) {
  // retrieve base inventory data from inventory collection
  const listing = {
    ...inventory[id]
  };

  // hydrate owner data if listing only has the identifier
  // check for number type to allow for backwards compatability with pre-defined owner data
  if (typeof listing.owner === 'number' && owners[listing.owner]) {
    listing.owner = {
      ...owners[listing.owner]
    };
  }

  // Franchise dealers exist!
  // Listings may have specific owner information we need to override the standard owner response with
  if (typeof listing.owner === 'object') {
    listing.owner.name = listing.ownerName || listing.owner.name;
    listing.owner.phone = listing.phone || listing.owner.phone;
  }
  listing.type = getListingType(listing, brand);
  listing.title = `${listing.type} ${listing.year} ${extractName(listing.make)} ${extractName(listing.model)}`.trim();
  const trimValue = extractName(listing.trim);
  if (trimValue && trimValue?.toUpperCase() !== 'UNAVAIL') {
    listing.title = `${listing.title} ${trimValue}`;
  }

  // Display First OEM Package if less than 30 characters.
  const packageList = listing.packages;
  const hasPackages = Array.isArray(packageList) && packageList?.length > 0;
  const titleHasPackageName = listing?.title?.includes('w/');
  if (!titleHasPackageName && hasPackages) {
    const firstOEMPackage = extractName(packageList[0] ?? '');
    const packageName = firstOEMPackage?.length < 30 ? ` w/ ${firstOEMPackage}` : '';
    listing.title = `${listing.title}${packageName}`;
  }
  if (listing?.owner?.location?.address) {
    listing.titleLong = `${listing.title} ${listing.owner.location.address.city}, ${listing.owner.location.address.state} ${listing.owner.location.address.zip}`;
  }
  return listing;
}
export const utilities = {
  extractName,
  extractTypeFromTypes,
  getListingType
};